import { getConvivaViewerSession } from '@optools/services/conviva/convivaSession';
import { ViewerSession } from '@optools/services/conviva/types';

import { apiSlice } from './apiSlice';

export const convivaApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    sessions: builder.query<ViewerSession[], string>({
      keepUnusedDataFor: 0,
      queryFn: async (oktaId) => {
        try {
          const data = await getConvivaViewerSession(oktaId);
          return { data };
        } catch (error: unknown) {
          return { error: `Conviva Sessions Error: ${(error as Error)?.message}` };
        }
      },
    }),
  }),
});

export const { useSessionsQuery } = convivaApiSlice;
